import { withVersions } from "v2/hocs/withVersions";
import { EmailCheckBlocker as EmailCheckBlockerV1 } from "./EmailCheckBlocker/v1";
import { EmailCheckBlocker as EmailCheckBlockerV2 } from "./EmailCheckBlocker/v2";
import withEmailCheckBlocker from "../hocs/withEmailCheckBlocker";

const EmailCheckBlocker = withVersions({
  v1: withEmailCheckBlocker(EmailCheckBlockerV1),
  v2: withEmailCheckBlocker(EmailCheckBlockerV2),
});

export default EmailCheckBlocker;
